import { getDatabase, ref, child, update, get, set, remove, push } from "firebase/database";
import { getDownloadURL, ref as ref_storage, getStorage, uploadBytesResumable } from "firebase/storage";
import firebase, { auth } from "../../firebase/config";
import { v4 as uuid } from "uuid";
import { getFormatedValue } from "../../utils/utils";
import { ToastSuccess, ToastWarn } from "../../commonComponents/ToastHelper";
import { PDFToImage } from "react-pdf-to-image-light";
// import { client_storage } from "../../firebase/config_client";

const getNowTime = () => {
  const server_time = firebase.firestore.Timestamp.now();
  const now_time = new Date(server_time.seconds * 1000 + server_time.nanoseconds / 1000000);
  return now_time.toLocaleString();
};

export const setAnalysisId = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[START SET ANALYSIS]", item);
    dispatch({ type: "SET_ANALYSIS_ID", payload: item });
  };
};

const get_weight = (entities) => {
  // in the order : freight_amount - line_item : line_item/quantity - net_amount
  let weight = entities.filter((x) => x.type === "freight_amount");
  if (weight.length > 0) {
    return weight[0];
  } else {
    weight = entities.filter((x) => x.type === "line_item" && x.properties.filter((y) => y.type === "line_item/quantity"));
    if (weight.length > 0) {
      weight = weight[0].properties.filter((x) => x.type === "line_item/quantity")[0];
      return weight;
    } else {
      weight = entities.filter((x) => x.type === "net_amount");
      if (weight.length > 0) {
        return weight[0];
      } else {
        return null;
      }
    }
  }
};

const get_price = (entities) => {
  let price = entities.filter((x) => x.type === "total_amount");
  if (price.length > 0) {
    return price[0];
  } else {
    return null;
  }
};

const get_distance = async (entities) => {
  // let url = "http://localhost:5001/lokalite-saas/us-central1/app/getDistance";
  let url = "https://us-central1-lokalite-saas.cloudfunctions.net/app/getDistance";
  let origin = entities.filter((x) => x.type === "ship_from_address");
  if (origin.length > 0) {
    origin = origin[0].mentionText.replace("\n", "");
  } else {
    origin = null;
  }
  let destination = entities.filter((x) => x.type === "remit_to_address");
  if (destination.length > 0) {
    destination = destination[0].mentionText.replace("\n", "");
  } else {
    destination = null;
  }

  if (origin && destination) {
    console.log("fetching");
    let res;
    await fetch(`${url}?origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}}`)
      .then(async (response) => {
        return response.json();
      })
      .then((json) => {
        console.log("[getDistance sucess] - result: ", json.data);
        res = json.data;
      });
    if (res.status === "OK") {
      console.log("status is ok", res);
      return res;
    }
  } else {
    console.log("NOT fetching distance");
    return null;
  }
};

export const uploadFiles = (items) => {
  return async (dispatch, getState, { getFirebase }) => {
    // DOC: https://firebase.google.com/docs/functions/callable
    // connect to local emulator for debug locally
    console.log("[UPLOAD_FILES] - INPUT", items, process.env.REACT_APP_NODE_ENV);
    const tenant_id = auth.currentUser.tenantId;
    // items.tenant_id = tenant_id;
    let url;
    if (process.env.REACT_APP_NODE_ENV === "DEV") {
      firebase.functions().useFunctionsEmulator("http://localhost:5001");
      url = "http://localhost:5001/lokalite-saas/us-central1/app/uploadFilesToCloudStorage";
    } else {
      url = "https://us-central1-lokalite-saas.cloudfunctions.net/app/uploadFilesToCloudStorage";
    }
    console.log("URL", url);

    const reponse = await fetch(url, {
      method: "POST",
      body: JSON.stringify({
        files: items.items,
        tenant_id: tenant_id,
      }),
      headers: { "Content-Type": "application/json" },
    });

    const json = await reponse.json();

    var format_data = async (x) => {
      // return new Promise((resolve, reject) => {
      // console.log(x);
      const mimeType = x.image.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)[1];
      // console.log("mimeType", mimeType);
      const weight = get_weight(x.entities);
      // console.log("weight OK");
      const distance = await get_distance(x.entities);
      // console.log("weight OK", distance);
      const price = get_price(x.entities);
      // console.log("weighxxt", weight);
      let results;
      if (mimeType === "application/pdf") {
        // console.log("isPDF");
        await PDFToImage({ blob: x.image, scale: 1 })
          .then((result) => {
            results = {
              entities: x.entities,
              fileName: x.fileName,
              image: result,
              selected_entities: [
                {
                  flow_category: { id: 1, name: "K_Transports", title: "de transport", unit: "Kg" },
                  weight: weight,
                  distance: distance,
                  price: price,
                },
              ],
            };
            // console.log("isPDF result", result);
          })
          .catch((error) => {
            console.log("PDFToImage Error", error);
          });
      } else {
        results = {
          ...x,
          selected_entities: [
            {
              flow_category: { id: 1, name: "K_Transports", title: "de transport", unit: "Kg" },
              weight: weight,
              distance: distance,
              price: price,
            },
          ],
        };
      }
      return results;
    };
    // };

    async function run_format_data(json) {
      let new_extracted_data = {};
      // json.forEach(async (x, index) => {
      //   new_extracted_data[index] = await format_data(x);
      // })
      console.log("NNNNtt", new_extracted_data);
      let i = 0;
      for (const x of json) {
        // await format_data(x).then((y) => new_extracted_data.push(x));
        // new_extracted_data.push(await format_data(x));
        new_extracted_data[i] = await format_data(x);
        i = i + 1;
      }
      return new_extracted_data;
    }

    // const result = await printElement(json);
    // console.log("result", result);
    await run_format_data(json)
      .then((res) => {
        console.log("res", res);
        dispatch({ type: "UPLOAD_FILES", payload: { res: res, step_index: items.step_index } });
      })
      .catch((error) => {
        console.log("[UPLOAD_FILES error]", error);
      });
  };
};

export const addEntitie = (item) => {
  return (dispatch, getState, { getFirebase }) => {
    // DOC: https://firebase.google.com/docs/functions/callable
    // connect to local emulator for debug locally
    console.log("[ADD_ENTITIE]", item);
    const state = getState();
    // get element index
    item.elem_index = Object.values(state.analysis.extracted_data[item.step_index]).indexOf(
      Object.values(state.analysis.extracted_data[item.step_index]).filter((x) => x.fileName === item.fileName)[0]
    );
    dispatch({ type: "ADD_ENTITIE", payload: item });
  };
};
export const setEntitieCategory = (item) => {
  return (dispatch, getState, { getFirebase }) => {
    // DOC: https://firebase.google.com/docs/functions/callable
    // connect to local emulator for debug locally
    console.log("[SET_ENTITIE_CATEGORY]", item);
    const state = getState();
    // get element index
    item.elem_index = Object.values(state.analysis.extracted_data[item.step_index]).indexOf(
      Object.values(state.analysis.extracted_data[item.step_index]).filter((x) => x.fileName === item.fileName)[0]
    );
    dispatch({ type: "SET_ENTITIE_CATEGORY", payload: item });
  };
};
export const setEntitieFlow = (item) => {
  return (dispatch, getState, { getFirebase }) => {
    // DOC: https://firebase.google.com/docs/functions/callable
    // connect to local emulator for debug locally
    console.log("[SET_ENTITIE_FLOW]", item);
    const state = getState();
    // get element index
    item.elem_index = Object.values(state.analysis.extracted_data[item.step_index]).indexOf(
      Object.values(state.analysis.extracted_data[item.step_index]).filter((x) => x.fileName === item.fileName)[0]
    );
    dispatch({ type: "SET_ENTITIE_FLOW", payload: item });
  };
};

export const removeEntite = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_ENTITE]", item);
    const state = getState();
    // get element index
    item.elem_index = Object.values(state.analysis.extracted_data[item.step_index]).indexOf(
      Object.values(state.analysis.extracted_data[item.step_index]).filter((x) => x.fileName === item.fileName)[0]
    );
    dispatch({
      type: "REMOVE_ENTITE",
      payload: item,
    });
  };
};

export const setExtractedData = (item) => {
  return (dispatch, getState, { getFirebase }) => {
    // DOC: https://firebase.google.com/docs/functions/callable
    // connect to local emulator for debug locally
    dispatch({ type: "SET_EXTRACTED_DATA", payload: item });
  };
};

// UPDATE FLOW QUANTITY
// const updateDocumentWeightLocal_fn = async (item) => {
//   const tenant_id = auth.currentUser.tenantId;
//   const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
//   const updates = {};
//   updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${item.process_id}/amount`] = item.quantity;
//   update(ref(database), updates);
// };
// export const updateFlowQuantity = (item) => {
//   return async (dispatch, getState, { getFirebase }) => {
//     console.log("[UPDATE_FLOW_QUANTITY_REMOTE]", item);
//     await updateFlowQuantity_fn(item);
//     dispatch({
//       type: "UPDATE_FLOW_QUANTITY_REMOTE",
//     });
//   };
// };

export const updateDocumentWeightLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_DOCUMENT_WEIGHT_LOCAL]", item);
    const state = getState();
    // get element index
    item.elem_index = parseFloat(Object.entries(state.analysis.extracted_data[item.step_index]).filter((x) => x[1].fileName === item.fileName)[0][0]);
    // console.log(Object.entries(state.analysis.extracted_data[item.step_index]).filter(x => x[1].fileName === item.fileName)[0][0])
    dispatch({
      type: "UPDATE_DOCUMENT_WEIGHT_LOCAL",
      payload: item,
    });
  };
};

export const updateDocumentPriceLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_DOCUMENT_PRICE_LOCAL]", item);
    const state = getState();
    // get element index
    // item.elem_index = Object.values(state.analysis.extracted_data[item.step_index]).indexOf(
    //   Object.values(state.analysis.extracted_data[item.step_index]).filter((x) => x.fileName === item.fileName)[0]
    // );
    item.elem_index = parseFloat(Object.entries(state.analysis.extracted_data[item.step_index]).filter((x) => x[1].fileName === item.fileName)[0][0]);
    dispatch({
      type: "UPDATE_DOCUMENT_PRICE_LOCAL",
      payload: item,
    });
  };
};
export const updateDocumentDistanceLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_DOCUMENT_DISTANCE_LOCAL]", item);
    const state = getState();
    // get element index
    item.elem_index = Object.values(state.analysis.extracted_data[item.step_index]).indexOf(
      Object.values(state.analysis.extracted_data[item.step_index]).filter((x) => x.fileName === item.fileName)[0]
    );
    dispatch({
      type: "UPDATE_DOCUMENT_DISTANCE_LOCAL",
      payload: item,
    });
  };
};

export const createAnalysis = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    // DOC: https://firebase.google.com/docs/functions/callable
    // connect to local emulator for debug locally
    console.log("[CREATE_ANALYSIS]", item, process.env.REACT_APP_NODE_ENV);
    let url;
    if (process.env.REACT_APP_NODE_ENV === "DEV") {
      firebase.functions().useFunctionsEmulator("http://localhost:5001");
      url = "http://localhost:5001/lokalite-saas/us-central1/app/createAnalysis";
    } else {
      url = "https://us-central1-lokalite-saas.cloudfunctions.net/app/createAnalysis";
    }
    await fetch(`${url}?user_id=${encodeURIComponent(item.user_id)}&ciqual_category_id=${encodeURIComponent(item.ciqual_category_id)}&tenant_id=${encodeURIComponent(item.tenant_id)}`)
      // console.log("resooo", await response.json())
      .then((response) => {
        // console.log('log', response.json())
        return response.json();
      })
      .then((json) => {
        console.log("[createAnalysis sucess] - analysis_id: ", json.data);
        dispatch({ type: "CREATE_ANALYSIS", payload: json });
      })
      .catch((error) => ToastWarn("Quelque chose s'est mal passé."));
  };
};

export const clear_create_analysis_result = () => {
  return async (dispatch, getState, { getFirebase }) => {
    dispatch({ type: "CLEAR_CREATE_ANALYSIS_RESULT" });
  };
};

export const removeAnalysis = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    // DOC: https://firebase.google.com/docs/functions/callable
    // connect to local emulator for debug locally
    console.log("[REMOVE_ANALYSIS]", item);
    const tenant_id = auth.currentUser.tenantId;
    const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
    // remove analysis analysis
    await remove(ref(database, `analysis/${item}`));
    // remove analysis history
    await remove(ref(database, `analysis_history/${item}`));
    dispatch({ type: "REMOVE_ANALYSIS" });
  };
};
export const removeAnalysisLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    // DOC: https://firebase.google.com/docs/functions/callable
    // connect to local emulator for debug locally
    console.log("[REMOVE_ANALYSIS_LOCAL]", item);
    dispatch({ type: "REMOVE_ANALYSIS_LOCAL", payload: item });
  };
};

export const setAnalysisData = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    const state = getState();
    const loading = state.analysis.loading;
    dispatch({
      type: "SET_ANALYSIS",
      payload: { data: data, loading: !loading },
    });
  };
};

export const fetchAnalysis = (analysis_id) => {
  return async (dispatch, getState, { getFirebase }) => {
    // RESOLVE CORSE ERROR (authorize local hots on gcloud) : https://stackoverflow.com/questions/37760695/firebase-storage-and-access-control-allow-origin
    // DOC: https://firebase.google.com/docs/functions/callable

    console.log("[START FETCH ANALYSIS]", analysis_id);
    const tenant_id = auth.currentUser.tenantId;
    const dbRef = ref(firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/"));
    await get(child(dbRef, `analysis/${analysis_id}`))
      .then(async (snapshot) => {
        if (await snapshot.exists()) {
          const data = snapshot.val();
          console.log("[END FETCH ANALYSIS] - RESULTS:", data);
          dispatch({
            type: "FETCH_ANALYSIS",
            payload: { data: data, loading: false },
          });
        } else {
          console.log("[END FETCH ANALYSIS] - NO DATA:");
          dispatch({
            type: "FETCH_ANALYSIS",
            payload: { data: null, loading: true },
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
};

const sort_analysis_history_by_date = async (analysis_history) => {
  var result = {};
  await Object.keys(analysis_history).forEach((key) => {
    result[key] = analysis_history[key];
    result[key]["createdAt"] = new Date(analysis_history[key]["createdAt"]);
  });
  console.log(result);

  const sorted_array = Object.entries(result).sort(function compare(a, b) {
    var dateA = a[1].createdAt;
    var dateB = b[1].createdAt;
    // console.log("dateA", dateA - dateB)
    return dateB - dateA;
  });

  var result_sorted = {};
  await sorted_array.map((x) => {
    result_sorted[x[0]] = x[1];
    const d = result_sorted[x[0]]["createdAt"];
    result_sorted[x[0]]["createdAt"] = d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() + ", " + d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
  });
  return result_sorted;
};

export const fetchAnalysisHistory = () => {
  return async (dispatch, getState, { getFirebase }) => {
    // RESOLVE CORSE ERROR (authorize local hots on gcloud) : https://stackoverflow.com/questions/37760695/firebase-storage-and-access-control-allow-origin
    // DOC: https://firebase.google.com/docs/functions/callable
    console.log("[FETCH_ANALYSIS_HISTORY]");
    const tenant_id = auth.currentUser.tenantId;
    const dbRef = ref(firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/"));

    await get(child(dbRef, "analysis_history/"))
      .then(async (snapshot) => {
        if (await snapshot.exists()) {
          const data = await snapshot.val();
          // console.log("[FETCH_ANALYSIS_HISTORY] - DONE:", data);
          const history_sorted = await sort_analysis_history_by_date(data);
          console.log("[FETCH_ANALYSIS_HISTORY] - DONE:", history_sorted);
          dispatch({
            type: "FETCH_ANALYSIS_HISTORY",
            payload: { history: history_sorted, loading: false },
          });
        } else {
          dispatch({
            type: "FETCH_ANALYSIS_HISTORY",
            payload: { history: [], loading: false },
          });
        }
      })
      .catch((error) => {
        console.error("[FETCH_ANALYSIS_HISTORY] - ERROR:", error);
      });
  };
};

export const setAnalysisHistory = (data) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[SET_ANALYSIS_HISTORY_FILTRED]", data);
    dispatch({
      type: "SET_ANALYSIS_HISTORY_FILTRED",
      payload: { history: data, loading: false },
    });
  };
};

////////////////////////////////////////////////////////////////////////////////////
///////////////////////// --------- ECO-SCORE --------- ////////////////////////////
////////////////////////////////////////////////////////////////////////////////////
export const calculEcoScore = async (item) => {
  // return async (dispatch, getState, { getFirebase }) => {
  let eco_score;

  let url;
  if (process.env.REACT_APP_NODE_ENV == "DEV") {
    firebase.functions().useFunctionsEmulator("http://localhost:5001");
    url = "http://localhost:5001/lokalite-saas/us-central1/app/calculEcoScore";
  } else {
    url = "https://us-central1-lokalite-saas.cloudfunctions.net/app/calculEcoScore";
  }

  await fetch(`${url}?product_single_score=${encodeURIComponent(item.product_single_score)}
    &input_labels=${encodeURIComponent(item.input_labels)}
    &input_origins=${encodeURIComponent(item.input_origins)}
    &input_materiaux=${encodeURIComponent(item.input_materiaux)}
    &huile_de_palme=${encodeURIComponent(item.huile_de_palme)}`)
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      eco_score = json.data.normalized_single_score;
      // dispatch({ type: "CALCUL_ECO_SCORE", payload: json.data.normalized_single_score });
    });
  return eco_score;
  // };
};

export const setEcoScoreRemote = async (item) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // create updates
  const updates = {};
  updates[`analysis/${item.analysis_id}/eco_score`] = item.eco_score;
  updates[`analysis/${item.analysis_id}/unique_score`] = item.unique_score;
  updates[`analysis_history/${item.analysis_id}/eco_score`] = item.eco_score;
  // send updates
  update(ref(database), updates);
};

export const getEcoScore = async (analysis_id) => {
  const tenant_id = auth.currentUser.tenantId;
  const dbRef = ref(firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/"));
  await get(child(dbRef, `analysis/${analysis_id}/eco_score`)).then(async (snapshot) => {
    if (await snapshot.exists()) {
      const data = snapshot.val();
      return data;
    } else {
      return null;
    }
  });
};

export const setProductNameLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log('SET_PRODUCT_NAME_LOCAL', item)
    const state = getState();
    Object.values(state.analysis.analysis_data.lca.lca_steps).map((x,i) => {
      dispatch({ type: "SET_PRODUCT_NAME_LOCAL", payload: {item: item, index: i} });
    })
  };
};
export const setProductName = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log('SET_PRODUCT_NAME', item)
    const tenant_id = auth.currentUser.tenantId;
    const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
    const state = getState();
    const updates = {};
    Object.values(state.analysis.analysis_data.lca.lca_steps).map((x,i) => {
      updates[`analysis/${state.analysis.analysis_id}/lca/lca_steps/${i}/ciqual_name`] = {fr: item, en: item};
    })
    updates[`analysis_history/${state.analysis.analysis_id}/product_name`] = item;
    update(ref(database), updates);
    dispatch({ type: "SET_PRODUCT_NAME"});
  };
};





////////////////////////////////////////////////////////////////////////////////////
//////////////////////// --------- UNDO / REDO --------- ///////////////////////////
////////////////////////////////////////////////////////////////////////////////////

// UNDO/ REDO SET TO UPDATE REMOTE
export const setRemoteUndoToUpdateItem = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[SET_REMOTE_UNDO_TO_UPDATE_ITEM]", item);
    dispatch({ type: "SET_REMOTE_UNDO_TO_UPDATE_ITEM", payload: item });
  };
};
const get_transport_country = (description) => {
  if (description.includes("Transport for")) {
    const country = description.split(" for ")[1].split(" ")[0];
    return country;
  } else {
    return "NAN";
  }
};
// UNDO UPDATE REMOTE
// export const updateRemoteUndoItem = (item) => {
//   return async (dispatch, getState, { getFirebase }) => {
//     console.log("[------------ UPDATE_REMOTE_UNDO_ITEM]", item);
//     const state = getState();

//     // TABLE QUANTITY
//     if (item.type === "flow_quantity") {
//       // works for ingredients and flows
//       item.quantity = state.analysis.past.slice(-1)[0].analysis_data.lca.lca_steps[item.step_index].inputs[item.process_id].amount;
//       updateQuantityTable_fn(getState, item);
//     }

//     // LABELS
//     else if (item.type === "add_label") {
//       // item.label = state.analysis.past.slice(-1)[0].analysis_data.labels;
//       removeLabel_fn(getState, item, false);
//     } else if (item.type === "remove_label") {
//       // item.label = state.analysis.past.slice(-1)[0].analysis_data.labels;
//       addLabel_fn(getState, item, false);
//     }

//     // ECO-PACKAGING
//     else if (item.type === "add_eco_packaging") {
//       console.log("add_eco_packaging", item);
//       removeEcoPackaging_fn(getState, item);
//     } else if (item.type === "remove_eco_packaging") {
//       addEcoPackaging_fn(getState, item, false);
//     } else if (item.type === "update_eco_packaging_format") {
//       item.value = state.analysis.past.slice(-1)[0].analysis_data.eco_packaging[item.eco_packaging_remote_key].format;
//       updateEcoPackagingFormat_fn(getState, item);
//     } else if (item.type === "update_eco_packaging_material") {
//       item.value = state.analysis.past.slice(-1)[0].analysis_data.eco_packaging[item.eco_packaging_remote_key].material;
//       updateEcoPackagingMaterial_fn(getState, item);
//     }

//     // INGREDIENT ORIGIN
//     else if (item.type === "update_origin_quantity") {
//       // update quantity
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Raw_Materials");
//       item.quantity = state.analysis.past.slice(-1)[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_origin].amount;
//       updateOriginQuantity_fn(item, getState, false);
//     } else if (item.type === "origin_value") {
//       // update value
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Raw_Materials");
//       item.quantity = state.analysis.past.slice(-1)[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_origin].origin;
//       updateOriginValue_fn(item, getState);
//     } else if (item.type === "add_origin") {
//       // add origin
//       removeOrigin_fn(item, getState, false);
//     } else if (item.type === "remove_origin") {
//       // remove origin
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Raw_Materials");
//       const past_ingredients = state.analysis.past.slice(-1)[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs;
//       const present_ingredients = state.analysis.analysis_data.ingredients[item.flow_id][index_raw_id].inputs;
//       let index_found;
//       Object.values(past_ingredients).map((x, i) => {
//         if (!present_ingredients.map((y) => y.id).includes(x.id)) {
//           item.data = x;
//           index_found = i;
//         }
//       });
//       const tenant_id = auth.currentUser.tenantId;
//       const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
//       const response = await get(child(ref(database), `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${index_raw_id}/inputs/`));
//       const remote_keys = Object.keys(response.val()).map((x) => parseFloat(x));
//       while (remote_keys.includes(index_found)) {
//         index_found = index_found + 1;
//       }
//       await addOrigin_fn(item, getState, getFirebase, false, false, true, index_found);
//     }

//     // INGREDIENT TRANSPORT
//     else if (item.type === "ingredient_transport_quantity") {
//       // update quantity
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Transports");
//       item.quantity = state.analysis.past.slice(-1)[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_transport].amount;
//       updateIngredientTransportQuantity_fn(item, getState, false);
//     } else if (item.type === "ingredient_transport_type") {
//       // update value
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Transports");
//       item.current = state.analysis.past.slice(-1)[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_transport];
//       updateIngredientTransport_fn(item, getState, getFirebase, false, true);
//     } else if (item.type === "add_ingredient_transport") {
//       // add transport
//       removeIngredientTransport_fn(getState, item, false);
//     } else if (item.type === "remove_ingredient_transport") {
//       // remove transport
//       console.log("[UNDO remove_ingredient_transport]");
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Transports");
//       const past_ingredients = state.analysis.past.slice(-1)[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs;
//       const present_ingredients = state.analysis.analysis_data.ingredients[item.flow_id][index_raw_id].inputs;
//       let index_found;
//       Object.values(past_ingredients).map((x, i) => {
//         if (!present_ingredients.map((y) => y.id).includes(x.id)) {
//           item.data = x;
//           index_found = i;
//         }
//       });
//       const tenant_id = auth.currentUser.tenantId;
//       const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
//       const response = get(child(ref(database), `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${index_raw_id}/inputs/`));
//       const remote_keys = Object.keys(response.val()).map((x) => parseFloat(x));
//       while (remote_keys.includes(index_found)) {
//         index_found = index_found + 1;
//       }
//       item.current = state.analysis.past.slice(-1)[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_transport];
//       addIngredientTransport_fn(getState, item, getFirebase, false, true, index_found);
//     } else if (item.type === "update_transport_origin") {
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Transports");
//       item.quantity = get_transport_country(state.analysis.past.slice(-1)[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_transport].description);
//       updateIngredientTransportOrigin_fn(item, getState, false);
//     }

//     // // FLOW
//     else if (item.type === "update_flow_type") {
//       // update flow type (update quantity is same as table quantity)
//       item.current = state.analysis.past.slice(-1)[0].analysis_data.lca.lca_steps[item.step_index].inputs[item.process_id];
//       await updateFlow_fn(item, getState, getFirebase, false, true);
//     } else if (item.type === "add_flow") {
//       // add flow
//       await removeFlowFromStep_fn(getState, item);
//     } else if (item.type === "remove_flow") {
//       // remove flow
//       // TODO check wot
//       item.current = state.analysis.past.slice(-1)[0].analysis_data.lca.lca_steps[item.step_index].inputs[item.process_id];
//       await addFlowToStep_fn(getState, item, getFirebase, false, false, true);
//     } else if (item.type === "add_ingredient") {
//       // add ingredient
//       await removeIngredient_fn(item, getState);
//     } else if (item.type === "remove_ingredient") {
//       // remove ingredient
//       item.current_ingredient = state.analysis.past.slice(-1)[0].analysis_data.ingredients[item.flow_id];
//       item.current_flow = state.analysis.past.slice(-1)[0].analysis_data.lca.lca_steps[item.step_index].inputs[item.process_id];
//       console.log("itemUNDO", item);
//       await addIngredient_fn(getState, item, getFirebase, false, true);
//     }
//     dispatch({ type: "UPDATE_REMOTE_UNDO_ITEM" });
//   };
// };
// // REDO UPDATE REMOTE
// export const updateRemoteRedoItem = (item) => {
//   return async (dispatch, getState, { getFirebase }) => {
//     console.log("[222 UPDATE_REMOTE_REDO_ITEM]", item);
//     // IMPORTANT : get previous state "remote_undo_to_update_item"
//     const state = getState();
//     item = state.analysis.future[0].remote_undo_to_update_item;
//     console.log("[FFUTUR 222 UPDATE_REMOTE_REDO_ITEM]", item);

//     // TABLE QUANTITTY
//     if (item.type === "flow_quantity") {
//       console.log("[UNDO update remote flow_quantity]");
//       item.quantity = state.analysis.future[0].analysis_data.lca.lca_steps[item.step_index].inputs[item.process_id].amount;
//       updateQuantityTable_fn(getState, item);
//     }

//     // LABELS
//     else if (item.type === "add_label") {
//       addLabel_fn(getState, item, false);
//     } else if (item.type === "remove_label") {
//       removeLabel_fn(getState, item, false);
//     }

//     // ECO-PACKAGING
//     else if (item.type === "add_eco_packaging") {
//       addEcoPackaging_fn(getState, item, false);
//     } else if (item.type === "remove_eco_packaging") {
//       removeEcoPackaging_fn(getState, item);
//     } else if (item.type === "update_eco_packaging_format") {
//       item.value = state.analysis.future[0].analysis_data.eco_packaging[item.eco_packaging_remote_key].format;
//       updateEcoPackagingFormat_fn(getState, item);
//     } else if (item.type === "update_eco_packaging_material") {
//       item.value = state.analysis.future[0].analysis_data.eco_packaging[item.eco_packaging_remote_key].material;
//       updateEcoPackagingMaterial_fn(getState, item);
//     }

//     // INGREDIENT ORIGIN
//     else if (item.type === "update_origin_quantity") {
//       // update quantity
//       console.log("[UNDO update remote update_origin_quantity]");
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Raw_Materials");
//       item.quantity = state.analysis.future[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_origin].amount;
//       updateOriginQuantity_fn(item, getState);
//     } else if (item.type === "origin_value") {
//       // update value
//       console.log("[UNDO update remote origin_value]");
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Raw_Materials");
//       item.quantity = state.analysis.future[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_origin].origin;
//       updateOriginValue_fn(item, getState, false);
//     } else if (item.type === "add_origin") {
//       // add orgin
//       console.log("[redo add_origin]");
//       addOrigin_fn(item, getState, getFirebase, false, true);
//     } else if (item.type === "remove_origin") {
//       // remove origin
//       console.log("[redo remove_origin]");
//       // SEE DOWN FOR PREVIOUS
//       removeOrigin_fn(item, getState, false);
//     }

//     // INGREDIENT TRANSPORT
//     else if (item.type === "ingredient_transport_quantity") {
//       console.log("[UNDO update remote transport_quantity]"); // update quantity
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Transports");
//       item.quantity = state.analysis.future[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_transport].amount;
//       updateIngredientTransportQuantity_fn(item, getState);
//     } else if (item.type === "ingredient_transport_type") {
//       // update value
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Transports");
//       item.current = state.analysis.future[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_transport];
//       updateIngredientTransport_fn(item, getState, getFirebase, false);
//     } else if (item.type === "add_ingredient_transport") {
//       // add transport
//       addIngredientTransport_fn(getState, item, getFirebase, false, false);
//     } else if (item.type === "remove_ingredient_transport") {
//       // remove transport
//       console.log("[UNDO remove_ingredient_transport]", item);
//       removeIngredientTransport_fn(getState, item, false);
//     } else if (item.type === "update_transport_origin") {
//       const [index_raw_id] = get_index_raw_id(getState, item, "K_Transports");
//       item.quantity = get_transport_country(state.analysis.future[0].analysis_data.ingredients[item.flow_id][index_raw_id].inputs[item.index_transport].description);
//       updateIngredientTransportOrigin_fn(item, getState, false);
//     }
//     // FLOW
//     else if (item.type === "update_flow_type") {
//       // update flow type (update quantity is same as table quantity)
//       console.log("[REOD update_flow_type]", item);
//       item.current = state.analysis.future[0].analysis_data.lca.lca_steps[item.step_index].inputs[item.process_id];
//       console.log("GO to: ", item.current);
//       await updateFlow_fn(item, getState, getFirebase, false, true);
//     } else if (item.type === "add_flow") {
//       // remove flow
//       console.log("[REDO add_flow]", item);
//       item.current = state.analysis.future[0].analysis_data.lca.lca_steps[item.step_index].inputs[item.process_id];
//       console.log("backing to: ", item.current);
//       await addFlowToStep_fn(getState, item, getFirebase, false, true, false);
//     } else if (item.type === "remove_flow") {
//       // add flow
//       await removeFlowFromStep_fn(getState, item);
//     } else if (item.type === "remove_ingredient") {
//       // remove ingredient
//       await removeIngredient_fn(item, getState);
//     } else if (item.type === "add_ingredient") {
//       // add ingredient
//       // await addIngredient_fn(item, getState);
//       await addIngredient_fn(getState, item, getFirebase, false, true);
//     }
//     dispatch({ type: "UPDATE_REMOTE_REDO_ITEM" });
//   };
// };

////////////////////////////////////////////////////////////////////////////////////
/////////////////////// --------- ECO-PACKAGING --------- //////////////////////////
////////////////////////////////////////////////////////////////////////////////////

// ADD ECO-PACKAGING
const addEcoPackaging_fn = async (getState, item, is_local) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // get label new ID
  const eco_packaging_remote_key = item.eco_packaging_remote_key ? item.eco_packaging_remote_key : push(child(ref(database), `analysis/${item.analysis_id}/eco_packaging`)).key;
  if (is_local) {
    return eco_packaging_remote_key;
  } else {
    // create updates
    const updates = {};
    updates[`analysis/${item.analysis_id}/eco_packaging/${eco_packaging_remote_key}`] = item.value;
    // send updates
    update(ref(database), updates);
  }
};
export const addEcoPackaging = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_ECO_PACKAGING]", item);
    await addEcoPackaging_fn(getState, item, false);
    dispatch({
      type: "ADD_ECO_PACKAGING",
    });
  };
};
export const addEcoPackagingLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_ECO_PACKAGING]", item);
    const eco_packaging_remote_key = await addLabel_fn(getState, item, true);
    console.log("eco_packaging_remote_key", eco_packaging_remote_key);
    dispatch({
      type: "ADD_ECO_PACKAGING_LOCAL",
      payload: {
        item: {
          analysis_id: item.analysis_id,
          value: item.value,
          eco_packaging_remote_key: eco_packaging_remote_key,
          type: item.type,
        },
      },
    });
    return eco_packaging_remote_key;
  };
};
// REMOVE ECO-PACKAGING
const removeEcoPackaging_fn = async (getState, item) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // const response = await get(child(ref(database), `analysis/${item.analysis_id}/eco_packaging/`));
  // const eco_packaging_id_remote = Object.entries(response.val()).find((x) => x[1].format.format === item.value.format.format && x[1].material.materiaux === item.value.material.materiaux)[0];
  // console.log("eco_packaging_id_remote", item.value[0]);
  await remove(ref(database, `analysis/${item.analysis_id}/eco_packaging/${item.eco_packaging_remote_key}`));
};
export const removeEcoPackaging = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_ECO_PACKAGING]", item);
    await removeEcoPackaging_fn(getState, item);
    dispatch({ type: "REMOVE_ECO_PACKAGING" });
  };
};
export const removeEcoPackagingLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_ECO_PACKAGING_LOCAL]", item);
    dispatch({ type: "REMOVE_ECO_PACKAGING_LOCAL", payload: { item: item } });
  };
};
// UPDATE ECO_PACKGING FORMAT
const updateEcoPackagingFormat_fn = async (getState, item) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const updates = {};
  updates[`analysis/${item.analysis_id}/eco_packaging/${item.eco_packaging_remote_key}/format`] = item.value;
  update(ref(database), updates);
};
export const updateEcoPackagingFormat = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_ECO_PACKAGING_FORMAT]", item);
    await updateEcoPackagingFormat_fn(getState, item);
    dispatch({ type: "UPDATE_ECO_PACKAGING_FORMAT" });
  };
};
export const updateEcoPackagingFormatLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_ECO_PACKAGING_FORMAT_LOCAL]", item);
    dispatch({ type: "UPDATE_ECO_PACKAGING_FORMAT_LOCAL", payload: { item: item } });
  };
};
// UPDATE ECO_PACKGING MATERIAL
const updateEcoPackagingMaterial_fn = async (getState, item) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const updates = {};
  updates[`analysis/${item.analysis_id}/eco_packaging/${item.eco_packaging_remote_key}/material`] = item.value;
  update(ref(database), updates);
};
export const updateEcoPackagingMaterial = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_ECO_PACKAGING_MATERIAL]", item);
    await updateEcoPackagingMaterial_fn(getState, item);
    dispatch({ type: "UPDATE_ECO_PACKAGING_MATERIAL" });
  };
};
export const updateEcoPackagingMaterialLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_ECO_PACKAGING_MATERIAL_LOCAL]", item);
    dispatch({ type: "UPDATE_ECO_PACKAGING_MATERIAL_LOCAL", payload: { item: item } });
  };
};

////////////////////////////////////////////////////////////////////////////////////
/////////////////////////// --------- CHCKED --------- /////////////////////////////
////////////////////////////////////////////////////////////////////////////////////

export const setCheckedFlowLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("SET_CHECKED_FLOW_LOCAL", item);
    const state = getState();
    const analysis_data = state.analysis.analysis_data;
    // item.process_id = uuid();
    if (item.k_type === "K_Wastes" || item.k_type === "K_Food_Given") {
      console.log("analysis_da", analysis_data.lca.lca_steps[item.step_index].outputs);
      item.process_id = parseFloat(Object.entries(analysis_data.lca.lca_steps[item.step_index].outputs).find((x) => x[1].id === item.flow_id)[0]);
    } else {
      item.process_id = parseFloat(Object.entries(analysis_data.lca.lca_steps[item.step_index].inputs).find((x) => x[1].id === item.flow_id)[0]);
    }
    console.log("item", item.process_id);
    dispatch({ type: "SET_CHECKED_FLOW_LOCAL", payload: { item: item } });
  };
};
export const setCheckedFlow = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("SET_CHECKED_FLOW", item);
    const tenant_id = auth.currentUser.tenantId;
    const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
    // // create updates
    const updates = {};
    const state = getState();
    const analysis_data = state.analysis.analysis_data;
    if (item.is_proxy) {
      updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/outputs/0/checked`] = item.value;
    } else {
      let flow_id_remote = await get_flow_id_remote(database, item, analysis_data);
      if (item.k_type === "K_Wastes" || item.k_type === "K_Food_Given") {
        updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/outputs/${flow_id_remote}/checked`] = item.value;
      } else {
        updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${flow_id_remote}/checked`] = item.value;
      }
    }
    // // send updates
    update(ref(database), updates);
    dispatch({ type: "SET_CHECKED_FLOW" });
  };
};
export const setAllChecked = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("SET_ALL_CHECKED", item);
    const tenant_id = auth.currentUser.tenantId;
    const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
    const updates = {};
    updates[`analysis_history/${item.analysis_id}/status`] = item.status;
    update(ref(database), updates);
    dispatch({ type: "SET_ALL_CHECKED" });
  };
};
export const setAllCheckedLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    dispatch({ type: "SET_ALL_CHECKED_LOCAL", payload: item });
  };
};

////////////////////////////////////////////////////////////////////////////////////
/////////////////////////// --------- FORMAT --------- /////////////////////////////
////////////////////////////////////////////////////////////////////////////////////

export const fetchFormats = () => {
  return async (dispatch, getState, { getFirebase }) => {
    // RESOLVE CORSE ERROR (authorize local hots on gcloud) : https://stackoverflow.com/questions/37760695/firebase-storage-and-access-control-allow-origin
    const storage = getFirebase().storage();
    const pathReference = ref_storage(storage, "eco_score/format/format.json");
    await getDownloadURL(pathReference).then((url) => {
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log("FORMATS", json);
          dispatch({ type: "FETCH_FORMATS", payload: json });
        })
        .catch((error) => console.error(error));
    });
  };
};

////////////////////////////////////////////////////////////////////////////////////
////////////////////////// --------- MATERIALS --------- ///////////////////////////
////////////////////////////////////////////////////////////////////////////////////

export const fetchMaterials = () => {
  return async (dispatch, getState, { getFirebase }) => {
    // RESOLVE CORSE ERROR (authorize local hots on gcloud) : https://stackoverflow.com/questions/37760695/firebase-storage-and-access-control-allow-origin
    const storage = getFirebase().storage();
    const pathReference = ref_storage(storage, "eco_score/materiaux/materiaux.json");
    await getDownloadURL(pathReference).then((url) => {
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log("MATERIALS", json);
          dispatch({ type: "FETCH_MATERIALS", payload: json });
        })
        .catch((error) => console.error(error));
    });
  };
};

export const fetchImpactIndicators = () => {
  return async (dispatch, getState, { getFirebase }) => {
    // RESOLVE CORSE ERROR (authorize local hots on gcloud) : https://stackoverflow.com/questions/37760695/firebase-storage-and-access-control-allow-origin
    const storage = getFirebase().storage();
    const pathReference = ref_storage(storage, "impact_indicators/impactIndicators.json");
    await getDownloadURL(pathReference).then((url) => {
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log("IMPACT_INDICATORS", json);
          dispatch({ type: "FETCH_IMPACT_INDICATORS", payload: json });
        })
        .catch((error) => console.error(error));
    });
  };
};

////////////////////////////////////////////////////////////////////////////////////
/////////////////////////// --------- LABELS --------- /////////////////////////////
////////////////////////////////////////////////////////////////////////////////////

export const fetchLabels = () => {
  return async (dispatch, getState, { getFirebase }) => {
    // RESOLVE CORSE ERROR (authorize local hots on gcloud) : https://stackoverflow.com/questions/37760695/firebase-storage-and-access-control-allow-origin
    const storage = getFirebase().storage();
    const pathReference = ref_storage(storage, "eco_score/labels/labels.json");
    await getDownloadURL(pathReference).then((url) => {
      fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          console.log("LABELS", json);
          dispatch({ type: "FETCH_LABELS", payload: json });
        })
        .catch((error) => console.error(error));
    });
  };
};
// ADD LABEL
const addLabel_fn = async (getState, item, is_local) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // get label new ID
  const label_remote_key = item.label_remote_key ? item.label_remote_key : push(child(ref(database), `analysis/${item.analysis_id}/labels`)).key;
  if (is_local) {
    return label_remote_key;
  } else {
    // create updates
    const updates = {};
    updates[`analysis/${item.analysis_id}/labels/${label_remote_key}`] = item.label;
    // send updates
    update(ref(database), updates);
  }
};
export const addLabel = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_LABEL]", item);
    await addLabel_fn(getState, item, false);
    dispatch({
      type: "ADD_LABEL",
    });
  };
};
export const addLabelLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_LABEL_LOCAL]", item);
    const label_remote_key = await addLabel_fn(getState, item, true);
    dispatch({
      type: "ADD_LABEL_LOCAL",
      payload: {
        item: {
          analysis_id: item.analysis_id,
          label: item.label,
          label_remote_key: label_remote_key,
          type: item.type,
        },
      },
    });
    return label_remote_key;
  };
};
// REMOVE LABEL
const removeLabel_fn = async (getState, item) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  await remove(ref(database, `analysis/${item.analysis_id}/labels/${item.label_remote_key}`));
};
export const removeLabel = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_LABEL]", item);
    await removeLabel_fn(getState, item);
    dispatch({ type: "REMOVE_LABEL" });
  };
};
export const removeLabelLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_LABEL_LOCAL]", item);
    dispatch({ type: "REMOVE_LABEL_LOCAL", payload: { item: item } });
  };
};

////////////////////////////////////////////////////////////////////////////////////
////////////////////////// --------- PALM OIL --------- ////////////////////////////
////////////////////////////////////////////////////////////////////////////////////

// UPDATE PALM OIL
const updatePalmOil_fn = async (getState, item) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const updates = {};
  updates[`analysis/${item.analysis_id}/palm_oil/`] = item.value;
  update(ref(database), updates);
};
export const updatePalmOil = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_PALM_OIL]", item);
    await updatePalmOil_fn(getState, item);
    dispatch({ type: "UPDATE_PALM_OIL" });
  };
};
export const updatePalmOilLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_PALM_OIL_LOCAL]", item);
    dispatch({ type: "UPDATE_PALM_OIL_LOCAL", payload: { item: item } });
  };
};

////////////////////////////////////////////////////////////////////////////////////
/////////////////////// --------- TABLE QUANTITY --------- /////////////////////////
////////////////////////////////////////////////////////////////////////////////////

// UPDATE FLOW QUANTITY TABLE
const updateQuantityTable_fn = async (getState, item) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // create updates
  const updates = {};
  // not need to update remote impact factors : value of impact = quantity * imapct * conversion factor
  // update remote amount
  const state = getState();
  const analysis_data = state.analysis.analysis_data;
  if (item.is_proxy) {
    updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/outputs/0/amount`] = item.quantity;
  } else {
    let flow_id_remote = await get_flow_id_remote(database, item, analysis_data);
    updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/${item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"}/${flow_id_remote}/amount`] =
      item.quantity;
  }
  update(ref(database), updates);
};

export const updateQuantityTableLocal = (item) => {
  return (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_QUANTITY_TABLE_LOCAL]", item);
    dispatch({
      type: "UPDATE_QUANTITY_TABLE_LOCAL",
      payload: { item: item },
    });
  };
};
export const updateQuantityTable = (item) => {
  return (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_QUANTITY_TABLE_REMOTE]", item);
    updateQuantityTable_fn(getState, item);
    dispatch({
      type: "UPDATE_QUANTITY_TABLE_REMOTE",
    });
  };
};

// UPDATE OUTPUT QUANITTY
const updateOutputQuantity_fn = async (getState, item) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // create updates
  const updates = {};
  // not need to update remote impact factors : value of impact = quantity * imapct * conversion factor
  // update remote amount
  const state = getState();
  const analysis_data = state.analysis.analysis_data;

  let new_quantity = item.quantity;

  if (6 - item.step_index === 2) {
    // if the is ingredient
    if (analysis_data.ingredients) {
      // filter on ingredients
      const ingred = analysis_data.lca.lca_steps[4].inputs.filter((x) => x.flow.category.name == "K_Ingredients");
      // add them to the input quantity
      new_quantity = parseFloat(new_quantity) + parseFloat(ingred.reduce((acc, curr) => acc + curr.amount, 0));
    }
    console.log("NO_ING");
    // set ingredient quantity
    updates[`analysis/${item.analysis_id}/lca/lca_steps/${2}/outputs/0/amount`] = new_quantity;
    // update output quantity for all steps
    // let cum_waste =
    console.log("new_quantity", new_quantity);
    for (let i = 3; i >= 0; i--) {
      // check if any waste or given food
      console.log("INDEX", i);
      const wastes_and_given = analysis_data.lca.lca_steps[i].inputs.filter((x) => x.flow.category.name === "K_Wastes" || x.flow.category.name === "K_Food_Given");
      console.log("wastes_and_given", wastes_and_given);
      if (wastes_and_given.length > 0) {
        // remove quantity
        new_quantity = parseFloat(new_quantity) - parseFloat(wastes_and_given.reduce((acc, curr) => acc + curr.amount, 0));
      }
      // step remote
      updates[`analysis/${item.analysis_id}/lca/lca_steps/${i}/outputs/0/amount`] = new_quantity;
    }
  }
  // else {
  //   let flow_id_remote = await get_flow_id_remote(database, item, analysis_data);
  //   updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${flow_id_remote}/amount`] = item.quantity;
  // }
  update(ref(database), updates);
};
export const updateOutputQuantity = (item) => {
  return (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_OUTPUT_QUANTITY_REMOTE]", item);
    updateOutputQuantity_fn(getState, item);
    dispatch({
      type: "UPDATE_OUTPUT_QUANTITY_REMOTE",
    });
  };
};
export const updateOutputQuantityLocal = (item) => {
  return (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_OUTPUT_QUANTITY]", item);
    dispatch({
      type: "UPDATE_OUTPUT_QUANTITY",
      payload: {
        item: {
          analysis_id: item.analysis_id,
          flow_id: item.flow_id,
          step_index: item.step_index,
          process_id: item.process_id,
          quantity: item.quantity,
          previous_quantity: item.previous_quantity,
          type: item.type,
          is_proxy: item.is_proxy,
        },
      },
    });
  };
};

////////////////////////////////////////////////////////////////////////////////////
////////////////////////// --------- ING ORIGIN --------- //////////////////////////
////////////////////////////////////////////////////////////////////////////////////

// UPDATE ORIGIN QUANTITY
const updateOriginQuantity_fn = async (item, getState, is_local) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const [index_raw_id, analysis_data] = get_index_raw_id(getState, item, "K_Raw_Materials");
  item.index_raw_id = index_raw_id;
  if (is_local) {
    return item;
  } else {
    let flow_id_remote = await get_ingredient_id_remote(database, item, index_raw_id, analysis_data);
    const updates = {};
    updates[`analysis/${item.analysis_id}/ingredients/${item.flow_id}/${index_raw_id}/inputs/${flow_id_remote}/amount`] = item.quantity;
    await update(ref(database), updates);
  }
};
export const updateOriginQuantity = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_ORIGIN_QUANTITY_REMOTE]");
    await updateOriginQuantity_fn(item, getState, false);
    dispatch({
      type: "UPDATE_ORIGIN_QUANTITY_REMOTE",
    });
  };
};
export const updateOriginQuantityLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_ORIGIN_QUANTITY_LOCAL]", item);
    const new_item = await updateOriginQuantity_fn(item, getState, true);
    dispatch({
      type: "UPDATE_ORIGIN_QUANTITY_LOCAL",
      payload: {
        item: new_item,
      },
    });
  };
};
// UPDATE ORIGIN VALUE (COUNRTY)
const updateOriginValue_fn = async (item, getState, is_local) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const [index_raw_id, analysis_data] = get_index_raw_id(getState, item, "K_Raw_Materials");
  const [tranport_raw_id, tata] = get_index_raw_id(getState, item, "K_Transports");
  item.index_raw_id = index_raw_id;
  item.tranport_raw_id = tranport_raw_id;
  if (is_local) {
    return item;
    // return [index_raw_id, tranport_raw_id, analysis_data];
  } else {
    let flow_id_remote = await get_ingredient_id_remote(database, item, item.index_raw_id, analysis_data);
    const updates = {};
    updates[`analysis/${item.analysis_id}/ingredients/${item.flow_id}/${item.index_raw_id}/inputs/${flow_id_remote}/origin`] = item.quantity;
    update(ref(database), updates);

    const updates_tr = {};
    const response = await get(child(ref(database), `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${item.tranport_raw_id}/inputs/`));
    Object.entries(response.val()).map((x) => {
      if (get_transport_country(x[1].description) === item.current.origin) {
        updates_tr[`analysis/${item.analysis_id}/ingredients/${item.flow_id}/${item.tranport_raw_id}/inputs/${x[0]}/description`] = "Transport for " + item.quantity + " import";
      }
    });
    update(ref(database), updates_tr);
  }
};
export const updateOriginValue = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_ORIGIN_VALUE_REMOTE]");
    await updateOriginValue_fn(item, getState, false);
    dispatch({
      type: "UPDATE_ORIGIN_VALUE_REMOTE",
    });
  };
};

export const updateOriginValueLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_ORIGIN_VALUE_LOCAL]", item);
    // const [index_raw_id, tranport_raw_id, analysis_data] = await updateOriginValue_fn(item, getState, true);
    let new_item = await updateOriginValue_fn(item, getState, true);

    dispatch({
      type: "UPDATE_ORIGIN_VALUE_LOCAL",
      payload: {
        item: new_item,
      },
    });

    const state = getState();
    const analysis_data = state.analysis.analysis_data;

    analysis_data.ingredients[item.flow_id][item.tranport_raw_id] &&
      Object.entries(analysis_data.ingredients[item.flow_id][item.tranport_raw_id].inputs).map((x) => {
        if (get_transport_country(x[1].description) === item.current.origin) {
          new_item.index_transport = x[0];
          dispatch({
            type: "UPDATE_ORIGIN_TRANSPORT_VALUE_LOCAL",
            payload: {
              item: new_item,
            },
          });
        }
      });
  };
};
// ADD ORIGIN
const addOrigin_fn = async (item, getState, getFirebase, is_local, is_redo, is_undo, index_found) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const state = getState();
  const analysis_data = state.analysis.analysis_data;
  const [index_raw_id, toto] = get_index_raw_id(getState, item, "K_Raw_Materials");
  item.index_raw_id = index_raw_id;
  if (!item.index_raw_id && is_local) {
    item.is_new_raw = true;
    const new_data = analysis_data["ingredients"][item.flow_id][0];
    const process_id = analysis_data.ingredients[item.flow_id][0]["inputs"][0].process_id;
    item.flow_uid = uuid();
    item.raw_data = {
      __typename: new_data["__typename"],
      // description: "Inventory of AGRIBALYSE v3.1, 2022 (update to v3.1 in August 2022 by EVEA S.A.S Coopérative). See the complete description of AGRIBALYSE database. This process describes the average consumption mix of Shallot in France. Included activities are : production in country of origin and transport No production dataset was found. The proxy used is : Onions. Status: Finished"
      description: "",
      category: {
        __typename: "Category",
        category_path: ["K_Karbon_Modelizations", "Agricultural"],
        id: "b38cbf74-c772-4298-b068-6b82a7b626df",
        name: "K_Raw_Materials",
      },
      inputs: [
        {
          __typename: "Exchange",
          amount: 1, // ask user to set this value
          description: "FR used as a substitute", //json["description"],
          // description_fr: "FR utilisé comme substitut",
          // flow: new_data.flow,
          flow: Object.values(analysis_data.lca.lca_steps[item.step_index]["inputs"])[item.process_id].flow,
          id: item.flow_uid, // gen ID
          input: true,
          is_agricultural: false,
          is_proxy: false,
          // origin: "NAN",
          origin: "INDEF",
          origin_proxy: "FR", // origin proxy always france ?
          process_id: process_id, // same as other inputs
          quantitative_reference: false,
          unit: {
            __typename: "Unit",
            conversion_factor: 1,
            description: "Kilogram",
            id: "20aadc24-a391-41cf-b340-3e4529f44bde",
            name: "kg",
            reference_unit: true,
          },
          updatedAt: getNowTime(), // firebase.firestore.Timestamp.now(),
          updated_by: auth.currentUser.uid,
        },
      ],
      outputs: [
        {
          __typename: "Exchange",
          amount: 1,
          description: "",
          description_fr: "",
          id: uuid(),
          flow: Object.values(analysis_data.lca.lca_steps[item.step_index]["inputs"])[item.process_id].flow,
          input: false,
          is_agricultural: true,
          is_proxy: true,
          process_id: uuid(),
          quantitative_reference: true,
          updatedAt: new_data["updatedAt"],
          updated_by: new_data["updated_by"],
          unit: {
            __typename: "Unit",
            conversion_factor: 1,
            description: "Kilogram",
            id: "20aadc24-a391-41cf-b340-3e4529f44bde",
            name: "kg",
            reference_unit: true,
          },
        },
      ],
      id: uuid(),
      name: new_data["name"],
      updatedAt: new_data["updatedAt"],
      updated_by: new_data["updated_by"],
    };

    item.transport_data = {
      __typename: "Process",
      description: "Transport process",
      category: {
        __typename: "Category",
        category_path: ["K_Karbon_Modelizations", "Agricultural"],
        id: "5b931d00-7e49-4b35-8b79-2e6e6e23485c",
        name: "K_Transports",
      },
      inputs: [
        {
          __typename: "Exchange",
          amount: 1,
          description: "",
          flow: Object.values(analysis_data.lca.lca_steps[item.step_index]["inputs"])[item.process_id].flow,
          id: uuid(),
          input: true,
          is_agricultural: true,
          is_proxy: false,
          origin: "FR",
          origin_proxy: "",
          process_id: uuid(),
          quantitative_reference: false,
          unit: {
            __typename: "Unit",
            conversion_factor: 1,
            description: "Kilogram",
            id: "20aadc24-a391-41cf-b340-3e4529f44bde",
            name: "kg",
            reference_unit: true,
          },
          updatedAt: new_data["updatedAt"],
          updated_by: new_data["updated_by"],
        },
      ],
      outputs: {},
      id: uuid(),
      name: new_data["name"] + "[Transported]",
      updatedAt: new_data["updatedAt"],
      updated_by: new_data["updated_by"],
    };
  } else if (is_local) {
    // const process_id = analysis_data.ingredients[item.flow_id][item.index_raw_id]["inputs"][0].process_id;
    const process_id = uuid();
    const K_raw_output = analysis_data.ingredients[item.flow_id][item.index_raw_id].outputs[0];
    item.flow_uid = uuid();
    item.data = {
      __typename: "Exchange",
      amount: 1, // ask user to set this value
      description: "FR used as a substitute", //json["description"],
      // description_fr: "FR utilisé comme substitut",
      flow: K_raw_output.flow,
      id: item.flow_uid, // gen ID
      input: true,
      is_agricultural: false,
      is_proxy: false,
      // origin: "NAN",
      origin: "INDEF",
      origin_proxy: "FR", // origin proxy always france ?
      process_id: process_id, // same as other inputs
      quantitative_reference: false,
      unit: K_raw_output.unit,
      updatedAt: getNowTime(), // firebase.firestore.Timestamp.now(),
      updated_by: auth.currentUser.uid,
    };
  }

  if (is_local) {
    return item;
  } else {
    if (item.is_new_raw) {
      var inputs_len_new = Object.values(analysis_data["ingredients"][item.flow_id]).length - 2;
      set(ref(database, `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${inputs_len_new}`), item.transport_data);
      set(ref(database, `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${inputs_len_new + 1}`), item.raw_data);
    } else {
      // var inputs_len = analysis_data.ingredients[item.flow_id][item.index_raw_id]["inputs"].length;
      var inputs_len = 0;
      const response = await get(child(ref(database), `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${item.index_raw_id}/inputs/`));
      const remote_keys = response.val() ? Object.keys(response.val()).map((x) => parseFloat(x)) : [];
      while (remote_keys.includes(inputs_len)) {
        inputs_len = inputs_len + 1;
      }
      set(ref(database, `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${item.index_raw_id}/inputs/${is_redo ? inputs_len : is_undo ? index_found : inputs_len}`), item.data);
    }
  }
};
export const addOrigin = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_ORIGIN]", item);
    await addOrigin_fn(item, getState, getFirebase, false);
    dispatch({ type: "ADD_ORIGIN" });
  };
};
export const addOriginLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_ORIGIN_LOCAL]", item);
    const new_item = await addOrigin_fn(item, getState, getFirebase, true);
    dispatch({
      type: "ADD_ORIGIN_LOCAL",
      payload: { item: new_item },
    });
    return new_item;
  };
};
// REMOVE ORIGIN
const removeOrigin_fn = async (item, getState, is_local) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // when delete in rdb, it doesnt update ids. So we need to get them and match local id with remote id.
  const [index_raw_id, analysis_data] = get_index_raw_id(getState, item, "K_Raw_Materials");
  const [tranport_raw_id, _] = get_index_raw_id(getState, item, "K_Transports");
  if (is_local) {
    return [index_raw_id, tranport_raw_id, analysis_data];
  } else {
    let flow_id_remote = await get_ingredient_id_remote(database, item, index_raw_id, analysis_data);

    await remove(ref(database, `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${index_raw_id}/inputs/${flow_id_remote}`));

    const response = await get(child(ref(database), `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${tranport_raw_id}/inputs/`));
    response.val() &&
      Object.entries(response.val()).map(async (x) => {
        if (get_transport_country(x[1].description) === item.current.origin) {
          await remove(ref(database, `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${tranport_raw_id}/inputs/${x[0]}`));
          // updates_tr[`analysis/${item.analysis_id}/ingredients/${item.flow_id}/${tranport_raw_id}/inputs/${i}/description`] = "Transport for " + item.quantity + " import";
        }
      });

    return flow_id_remote;
  }
};
export const removeOrigin = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_ORIGIN]", item);
    const flow_id_remote = await removeOrigin_fn(item, getState, false);
    dispatch({ type: "REMOVE_ORIGIN", payload: flow_id_remote });
  };
};
export const removeOriginLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_ORIGIN_LOCAL]", item);
    const [index_raw_id, tranport_raw_id, analysis_data] = await removeOrigin_fn(item, getState, true);
    item.index_raw_id = index_raw_id;
    item.tranport_raw_id = tranport_raw_id;
    dispatch({
      type: "REMOVE_ORIGIN_LOCAL",
      payload: { item: item },
    });

    let deleted_count = 0;
    analysis_data.ingredients[item.flow_id][tranport_raw_id] &&
      Object.values(analysis_data.ingredients[item.flow_id][tranport_raw_id].inputs).map((x, i) => {
        if (get_transport_country(x.description) === item.current.origin) {
          deleted_count += 1;
          dispatch({
            type: "REMOVE_ORIGIN_TRANSPORT_LOCAL",
            payload: { item: item, target_id: i - deleted_count + 1 },
          });
        }
      });
  };
};

////////////////////////////////////////////////////////////////////////////////////
//////////////////////// --------- ING TRANSPORT --------- /////////////////////////
////////////////////////////////////////////////////////////////////////////////////

// UPDATE INGREDIENT TRANSPORT VALUE (TYPE)
const updateIngredientTransport_fn = async (item, getState, getFirebase, is_local, is_undo) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const [index_raw_id, analysis_data] = get_index_raw_id(getState, item, "K_Transports");

  let data;
  if (is_undo) {
    data = item.current;
  } else {
    const new_flow_id = item.quantity.id;
    const process_id = analysis_data.ingredients[item.flow_id][index_raw_id]["inputs"][0].process_id;
    const storage = getFirebase().storage();
    const pathReference = ref_storage(storage, "flows/" + new_flow_id + ".json");
    const downloadUrl = await getDownloadURL(pathReference);
    const response = await fetch(downloadUrl);
    const json = await response.json();
    data = {
      __typename: "Exchange",
      amount: item.current.amount, // ask user to set this value
      // description: json["description"],
      description: "Transport for " + item.origin + " import",
      description_fr: "",
      flow: json,
      id: item.current.id, // gen ID
      input: true,
      is_agricultural: false,
      process_id: process_id, // same as other inputs
      quantitative_reference: false,
      unit: json.unit,
      updatedAt: getNowTime(), // firebase.firestore.Timestamp.now(),
      updated_by: auth.currentUser.uid,
    };
  }

  if (is_local) {
    return [index_raw_id, data];
  } else {
    let flow_id_remote = await get_ingredient_id_remote(database, item, index_raw_id, analysis_data);
    const updates = {};
    updates[`analysis/${item.analysis_id}/ingredients/${item.flow_id}/${index_raw_id}/inputs/${flow_id_remote}`] = data;
    update(ref(database), updates);
  }
};
export const updateIngredientTransport = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_INGREDIENT_TRANSPORT]", item);
    await updateIngredientTransport_fn(item, getState, getFirebase, false);
    dispatch({ type: "UPDATE_INGREDIENT_TRANSPORT" });
  };
};
export const updateIngredientTransportLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_INGREDIENT_TRANSPORT_LOCAL]", item);
    const [index_raw_id, data] = await updateIngredientTransport_fn(item, getState, getFirebase, true);
    dispatch({
      type: "UPDATE_INGREDIENT_TRANSPORT_LOCAL",
      payload: {
        item: {
          origin: item.origin,
          analysis_id: item.analysis_id,
          flow_id: item.flow_id,
          index_raw_id: index_raw_id,
          index_transport: item.index_transport,
          quantity: item.quantity,
          current: item.current,
          step_index: item.step_index,
          type: item.type,
        },
        data: data,
      },
    });
  };
};
// UPDATE INGREDIENT TRANSPORT QUANTITY (KM)
const updateIngredientTransportQuantity_fn = async (item, getState, is_local) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // get analysis data
  // const [index_raw_id, analysis_data] = get_index_raw_id(getState, item, "K_Transports");
  const [index_raw_id, analysis_data] = get_index_raw_id(getState, item, "K_Transports");
  if (is_local) {
    return index_raw_id;
  } else {
    let flow_id_remote = await get_ingredient_id_remote(database, item, index_raw_id, analysis_data);
    const updates = {};
    console.log("");
    updates[`analysis/${item.analysis_id}/ingredients/${item.flow_id}/${index_raw_id}/inputs/${flow_id_remote}/amount`] = item.quantity;
    console.log("updating...", updates);
    await update(ref(database), updates);
  }
};
export const updateIngredientTransportQuantity = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_INGREDIENT_TRANSPORT_QUANTITY_REMOTE]");
    // update remote
    await updateIngredientTransportQuantity_fn(item, getState, false);
    dispatch({ type: "UPDATE_INGREDIENT_TRANSPORT_QUANTITY_REMOTE" });
  };
};
export const updateIngredientTransportLocalQuantity = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_INGREDIENT_TRANSPORT_QUANTITY_LOCAL]", item);
    const index_raw_id = await updateIngredientTransportQuantity_fn(item, getState, true);
    // console.log("++++ index_raw_id", index_raw_id);
    // console.log("++++ UPDATE_INGREDIENT_TRANSPORT_QUANTITY_LOCAL", {
    //   analysis_id: item.analysis_id,
    //   flow_id: item.flow_id,
    //   index_raw_id: index_raw_id,
    //   index_transport: item.index_transport,
    //   quantity: item.quantity,
    //   current: item.current,
    //   step_index: item.step_index,
    //   type: item.type,
    // });
    dispatch({
      type: "UPDATE_INGREDIENT_TRANSPORT_QUANTITY_LOCAL",
      payload: {
        item: {
          analysis_id: item.analysis_id,
          flow_id: item.flow_id,
          index_raw_id: index_raw_id,
          index_transport: item.index_transport,
          quantity: item.quantity,
          current: item.current,
          step_index: item.step_index,
          type: item.type,
        },
      },
    });
  };
};

// UPDATE INGREDIENT TRANSPORT ORIGIN
const updateIngredientTransportOrigin_fn = async (item, getState, is_local) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // get analysis data
  const [index_raw_id, analysis_data] = get_index_raw_id(getState, item, "K_Transports");
  if (is_local) {
    return index_raw_id;
  } else {
    let flow_id_remote = await get_ingredient_id_remote(database, item, index_raw_id, analysis_data);
    const updates = {};
    updates[`analysis/${item.analysis_id}/ingredients/${item.flow_id}/${index_raw_id}/inputs/${flow_id_remote}/description`] = "Transport for " + item.quantity + " import.";
    console.log("updating...", updates);
    await update(ref(database), updates);
  }
};
export const updateIngredientTransportOrigin = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_INGREDIENT_TRANSPORT_ORIGIN_REMOTE]");
    await updateIngredientTransportOrigin_fn(item, getState, false);
    dispatch({
      type: "UPDATE_INGREDIENT_TRANSPORT_ORIGIN_REMOTE",
    });
  };
};

export const updateIngredientTransportOriginLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_INGREDIENT_TRANSPORT_ORIGIN_LOCAL]", item);
    const index_raw_id = await updateIngredientTransportOrigin_fn(item, getState, true);
    dispatch({
      type: "UPDATE_INGREDIENT_TRANSPORT_ORIGIN_LOCAL",
      payload: {
        item: {
          analysis_id: item.analysis_id,
          flow_id: item.flow_id,
          index_raw_id: index_raw_id,
          index_transport: item.index_transport,
          quantity: item.quantity,
          current: item.current,
          step_index: item.step_index,
          type: item.type,
        },
      },
    });
  };
};

// ADD INGREDIENT TRANSPORT
const addIngredientTransport_fn = async (getState, item, getFirebase, is_local, is_undo, index_found) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");

  const state = getState();
  const analysis_data = state.analysis.analysis_data;

  if (is_local) {
    const [index_raw_id, toto] = get_index_raw_id(getState, item, "K_Transports");
    item.index_raw_id = index_raw_id;
    const process_id = uuid();
    const storage = getFirebase().storage();
    const pathReference = ref_storage(storage, "flows/" + (item.flow_meta ? item.flow_meta.id : item.flow_id) + ".json");
    const downloadUrl = await getDownloadURL(pathReference);
    const response = await fetch(downloadUrl);
    const json = await response.json();
    // flow_uid = item.flow_uid ? item.flow_uid : uuid();
    item.flow_uid = uuid();
    item.data = {
      __typename: "Exchange",
      amount: 1, // HEROOO
      // description: json["description"],
      description: "Transport for " + item.origin + " import",
      description_fr: "",
      flow: json,
      id: item.flow_uid, // gen ID
      input: true,
      is_agricultural: false,
      process_id: process_id, // same as other inputs
      quantitative_reference: false,
      unit: json.unit,
      updatedAt: getNowTime(), // firebase.firestore.Timestamp.now(),
      updated_by: auth.currentUser.uid,
    };
    return item;
  } else {
    // var inputs_len = analysis_data.ingredients[item.flow_id][item.index_raw_id]["inputs"].length;
    var inputs_len = 0;
    const response = await get(child(ref(database), `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${item.index_raw_id}/inputs/`));
    const remote_keys = Object.keys(response.val()).map((x) => parseFloat(x));
    while (remote_keys.includes(inputs_len)) {
      inputs_len = inputs_len + 1;
    }
    set(ref(database, `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${item.index_raw_id}/inputs/${inputs_len}`), item.data);
  }
};
export const addIngredientTransport = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_INGREDIENT_TRANSPORT]", item);
    await addIngredientTransport_fn(getState, item, getFirebase, false);
    dispatch({ type: "ADD_INGREDIENT_TRANSPORT" });
  };
};
export const addIngredientTransportLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_INGREDIENT_TRANSPORT_LOCAL]");
    const new_item = await addIngredientTransport_fn(getState, item, getFirebase, true);
    dispatch({
      type: "ADD_INGREDIENT_TRANSPORT_LOCAL",
      payload: {
        item: new_item,
      },
    });
    return new_item;
  };
};
// REMOVE TRANSPORT
const removeIngredientTransport_fn = async (getState, item, is_local) => {
  // console.log("[REMOVE_FLOW_FROM_STEP]", item);
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // when delete in rdb, it doesnt update ids. So we need to get them and match local id with remote id.
  const [index_raw_id, analysis_data] = get_index_raw_id(getState, item, "K_Transports");
  if (is_local) {
    return index_raw_id;
  } else {
    let flow_id_remote = await get_ingredient_id_remote(database, item, index_raw_id, analysis_data);
    await remove(ref(database, `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${index_raw_id}/inputs/${flow_id_remote}`));
  }
};
export const removeIngredientTransport = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_INGREDIENT_TRANSPORT]", item);
    await removeIngredientTransport_fn(getState, item, false);
    dispatch({ type: "REMOVE_INGREDIENT_TRANSPORT" });
  };
};
export const removeIngredientTransportLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_INGREDIENT_TRANSPORT_LOCAL]", item);
    item.index_raw_id = await removeIngredientTransport_fn(getState, item, true);
    dispatch({
      type: "REMOVE_INGREDIENT_TRANSPORT_LOCAL",
      payload: { item: item },
    });
  };
};

////////////////////////////////////////////////////////////////////////////////////
///////////////////////////// --------- FLOW --------- /////////////////////////////
////////////////////////////////////////////////////////////////////////////////////

async function get_flow_id_remote(database, item, analysis_data) {
  const response = await get(
    child(ref(database), `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/${item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"}/`)
  );
  let flow_id_remote;
  flow_id_remote = Object.entries(response.val()).find((x) => x[1].id === item.flow_id)[0];
  // flow_id_remote = Object.entries(response.val()).find((x) => x[1].flow.id === item.flow_id)[0];
  // if (item.current && item.current.id) {
  //   flow_id_remote = Object.entries(response.val()).find((x) => x[1].id === item.current.id)[0];
  // } else if (item.flow_id) {
  //   flow_id_remote = Object.entries(response.val()).find((x) => x[1].flow.id === item.flow_id)[0];
  // }
  return flow_id_remote;
}

// UPDATE FLOW
const updateFlow_fn = async (item, getState, getFirebase, is_local, is_undo) => {
  const state = getState();
  const analysis_data = state.analysis.analysis_data;
  let data;
  let flow_uid;
  if (is_undo) {
    data = item.current;
  } else {
    const storage = getFirebase().storage();
    const pathReference = ref_storage(storage, "flows/" + item.flow_meta.id + ".json");
    const downloadUrl = await getDownloadURL(pathReference);
    const response = await fetch(downloadUrl);
    const json = await response.json();
    const process_data = analysis_data.lca.lca_steps[item.step_index].inputs[item.process_id];
    // flow_uid = item.flow_uid ? item.flow_uid : uuid();
    data = {
      __typename: "Exchange",
      amount: process_data.amount,
      description: process_data.description,
      description_fr: process_data.description_fr,
      flow: json,
      // id: flow_uid, // gen ID
      id: process_data.id,
      input: true,
      is_agricultural: false,
      process_id: process_data.process_id, // same as other inputs
      quantitative_reference: false,
      unit: json.unit,
      updatedAt: getNowTime(), // firebase.firestore.Timestamp.now(),
      updated_by: auth.currentUser.uid,
    };
  }

  if (is_local) {
    return [data, flow_uid];
  } else {
    const tenant_id = auth.currentUser.tenantId;
    const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
    let flow_id_remote = await get_flow_id_remote(database, item, analysis_data);
    const updates = {};
    updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${flow_id_remote}`] = data;
    // updates[
    //   `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${item.process_id}`
    // ] = data;
    update(ref(database), updates);
  }
};
export const updateFlow = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_FLOW_REMOTE]");
    await updateFlow_fn(item, getState, getFirebase, false);
    dispatch({
      type: "UPDATE_FLOW_REMOTE",
    });
  };
};
export const updateFlowLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_FLOW_LOCAL]", item);
    const [data, flow_uid] = await updateFlow_fn(item, getState, getFirebase, true);
    dispatch({
      type: "UPDATE_FLOW_LOCAL",
      payload: {
        item: {
          analysis_id: item.analysis_id,
          step_index: item.step_index,
          process_id: item.process_id,
          current: item.current,
          type: item.type,
        },
        data: data,
      },
    });
    return flow_uid;
  };
};
// UPDATE FLOW QUANTITY
const updateFlowQuantity_fn = async (item, analysis_data) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const updates = {};
  let flow_id_remote = await get_flow_id_remote(database, item, analysis_data);
  updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/${item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"}/${flow_id_remote}/amount`] =
    item.quantity;
  // updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/${(item.k_type === "K_Wastes" || item.k_type === "K_Food_Given") ? "outputs" : "inputs"}/${item.process_id}/amount`] = item.quantity;
  update(ref(database), updates);
};
export const updateFlowQuantity = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_FLOW_QUANTITY_REMOTE]", item);
    const state = getState();
    const analysis_data = state.analysis.analysis_data;
    await updateFlowQuantity_fn(item, analysis_data);
    dispatch({
      type: "UPDATE_FLOW_QUANTITY_REMOTE",
    });
  };
};
export const updateFlowQuantityLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_FLOW_QUANTITY_LOCAL]", item);
    dispatch({
      type: "UPDATE_FLOW_QUANTITY_LOCAL",
      payload: {
        item: item,
      },
    });
  };
};
// ADD FLOW
const addFlowToStep_fn = async (getState, item, getFirebase, is_local, is_redo, is_undo) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const state = getState();

  // if (is_undo) {
  //   data = item.current;
  // } else {
  if (is_local) {
    // needed to create data model
    const process_id = Object.values(state.analysis.analysis_data.lca.lca_steps)[item.step_index]["inputs"]
      ? Object.values(Object.values(state.analysis.analysis_data.lca.lca_steps)[item.step_index]["inputs"])[0].process_id
      : Object.values(state.analysis.analysis_data.lca.lca_steps)[item.step_index]["outputs"][0].process_id;
    // needed +1 as a new key for realtime database

    // get flow data to write
    const storage = getFirebase().storage();
    const pathReference = ref_storage(storage, "flows/" + item.flow_meta.id + ".json");
    const downloadUrl = await getDownloadURL(pathReference);
    const response = await fetch(downloadUrl);
    const json = await response.json();
    console.log("jsonssss", json);
    // generate data flow_uid
    item.k_type = json.category.name;
    item.flow_uid = uuid();

    // set data format
    item.data = {
      __typename: "Exchange",
      amount: item.amount ? item.amount : 1, // ask user to set this value
      description: json["description"],
      price: item.price ? item.price : 0,
      fileName: item.fileName ? item.fileName : null,
      description_fr: "",
      flow: json,
      id: item.flow_uid,
      // id: item.flow_meta.id, // gen ID
      input: true,
      is_agricultural: false,
      process_id: process_id, // same as other inputs
      quantitative_reference: false,
      unit: json.unit,
      updatedAt: getNowTime(), // firebase.firestore.Timestamp.now(),
      updated_by: auth.currentUser.uid,
    };

    // inputs_len
    // item.inputs_len = Object.values(state.analysis.analysis_data.lca.lca_steps)[item.step_index][item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"]
    //   ? Object.values(Object.values(state.analysis.analysis_data.lca.lca_steps)[item.step_index][item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"]).length
    //   : 0;
    item.inputs_len = 0;

    return item;
  } else {
    const response = await get(
      child(ref(database), `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/${item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"}/`)
    );

    // if no reponse, means there is no inputs object. Set the keys to []
    const remote_keys = response.val() ? Object.keys(response.val()).map((x) => parseFloat(x)) : [];
    while (remote_keys.includes(item.inputs_len)) {
      item.inputs_len = item.inputs_len + 1;
    }
    set(
      ref(database, `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/${item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"}/${item.inputs_len}`),
      item.data
    );
  }
};
export const addFlowToStepLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_FLOW_TO_STEP_LOCAL]", item);
    const new_item = await addFlowToStep_fn(getState, item, getFirebase, true);
    dispatch({
      type: "ADD_FLOW_TO_STEP_LOCAL",
      payload: { item: new_item },
    });
    return new_item;
  };
};
export const addFlowToStepRemote = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    await addFlowToStep_fn(getState, item, getFirebase, false);
    ToastSuccess("Procédé ajouté.");
    dispatch({ type: "ADD_FLOW_TO_STEP_REMOTE" });
  };
};
// REMOVE FLOW
const removeFlowFromStep_fn = async (getState, item) => {
  const state = getState();
  const analysis_data = state.analysis.analysis_data;
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // when delete in rdb, it doesnt update ids. So we need to get them and match local id with remote id.
  // const response = await get(
  //   child(
  //     ref(database),
  //     `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/`
  //   )
  // );
  // const flow_id_remote = Object.entries(response.val())[item.process_id][0];
  const flow_id_remote = await get_flow_id_remote(database, item, analysis_data);

  await remove(ref(database, `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/${item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"}/${flow_id_remote}`));
  // console.log("REMOVING_REMOTE", flow_id_remote);
  // return parseFloat(flow_id_remote);
};
export const removeFlowFromStep = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_FLOW_FROM_STEP]", item);
    await removeFlowFromStep_fn(getState, item);
    ToastSuccess("Procédé supprimé.");
    // console.log("taatoo", flow_id_remote);
    dispatch({ type: "REMOVE_FLOW_FROM_STEP" });
    // return flow_id_remote;
  };
};
export const removeFlowFromStepLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_FLOW_FROM_STEP_LOCAL]", item);
    // item, analysis_data
    // get local waste id
    // Object.entries(analysis_data.lca.lca_steps[item.step_index].inputs)
    const state = getState();
    const analysis_data = state.analysis.analysis_data;
    // console.log("TAOTSOO", analysis_data.lca.lca_steps[item.step_index].inputs);
    // item.process_id = Object.entries(analysis_data.lca.lca_steps[item.step_index].inputs).findIndex((x) => x.flow.id === item.flow_id);
    // item.process_id = Object.entries(analysis_data.lca.lca_steps[item.step_index].inputs).find((x) => x[1].flow.id === item.flow_id)[0];
    item.process_id = parseFloat(
      Object.entries(analysis_data.lca.lca_steps[item.step_index][item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"]).find((x) => x[1].id === item.flow_id)[0]
    );
    // item.process_id = parseFloat(Object.entries(analysis_data.lca.lca_steps[item.step_index].inputs).find((x) => x[1].id === item.flow_id)[0]);
    console.log("REMOVE_FLOW_FROM_STEP_LOCAL", item);
    dispatch({ type: "REMOVE_FLOW_FROM_STEP_LOCAL", payload: { item: item } });
  };
};


const updateFlowDescription_fn = async (item, analysis_data) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const updates = {};
  let flow_id_remote = await get_flow_id_remote(database, item, analysis_data);
  updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/${item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"}/${flow_id_remote}/description`] = item.value;
  updates[`analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/${item.k_type === "K_Wastes" || item.k_type === "K_Food_Given" ? "outputs" : "inputs"}/${flow_id_remote}/description_fr`] = item.value;
  update(ref(database), updates);
};
export const updateFlowDescriptionLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log('UPDATE_FLOW_DESCRIPTION_LOCAL', item)
    // const state = getState();
      dispatch({ type: "UPDATE_FLOW_DESCRIPTION_LOCAL", payload: {item: item} });
  };
};
export const updateFlowDescription = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[UPDATE_FLOW_DESCRIPTION]", item);
    const state = getState();
    const analysis_data = state.analysis.analysis_data;
    await updateFlowDescription_fn(item, analysis_data);
    dispatch({
      type: "UPDATE_FLOW_DESCRIPTION",
    });
  };
};



// ADD INGREDIENT
const addIngredient_fn = async (getState, item, getFirebase, is_local, is_redo) => {
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  const state = getState();

  let data;
  let lca_data;
  let flow_uid;
  if (is_local) {
    /////////// INGREDIENT_DATA
    // needed to create data model
    const process_id = Object.values(Object.values(state.analysis.analysis_data.lca.lca_steps)[item.step_index]["inputs"])[0].process_id;
    // needed +1 as a new key for realtime database
    console.log("[ADD_INGREDIENT]", item, process_id);
    // get flow data to write
    const storage = getFirebase().storage();
    const pathReference = ref_storage(
      storage,
      `${item.k_type === "K_Cooking" || ["Eau municipale", "Eau de noix de coco", "Guimauve ou marshmallow"].includes(item.flow_meta.name) ? "flows" : "ingredients"}/` + item.flow_meta.id + ".json"
    );
    // const pathReference = ref_storage(storage, "ingredients/" + item.flow_id + ".json");
    const downloadUrl = await getDownloadURL(pathReference);
    const response = await fetch(downloadUrl);
    item.ingredient_data = await response.json();

    console.log("response", item.ingredient_data);

    /////////// LCA_DATA
    item.flow_uid = uuid();
    if (item.k_type === "K_Cooking" || ["Eau municipale", "Eau de noix de coco", "Guimauve ou marshmallow"].includes(item.flow_meta.name)) {
      item.lca_data = {
        amount: 1,
        description: "",
        flow: item.ingredient_data, // goes to flow when K_Cooking
        id: item.flow_uid,
        input: true,
        is_agricultural: true,
        process_id: process_id,
        quantitative_reference: false,
        unit: {
          __typename: "Unit",
          conversion_factor: 1,
          description: "Kilogram",
          id: "20aadc24-a391-41cf-b340-3e4529f44bde",
          name: "kg",
          reference_unit: true,
        },
        updatedAt: getNowTime(),
        updated_by: auth.currentUser.uid,
        __typename: "Exchange",
      };
    } else {
      var new_data = item.ingredient_data.filter((x) => x.category.name === "K_Ingredients")[0];
      console.log("new_data", new_data);
      if (!new_data) {
        new_data = item.ingredient_data[0];
      }
      new_data["outputs"][0]["flow"].id = item.flow_uid;
      item.lca_data = {
        amount: new_data["outputs"][0]["amount"], // default value
        description: new_data["outputs"][0]["flow"]["description"],
        flow: new_data["outputs"][0]["flow"],
        id: item.flow_uid,
        input: true,
        is_agricultural: new_data["outputs"][0]["is_agricultural"],
        process_id: process_id,
        quantitative_reference: new_data["outputs"][0]["quantitative_reference"],
        unit: new_data["outputs"][0]["unit"],
        updatedAt: getNowTime(),
        updated_by: auth.currentUser.uid,
        __typename: "Exchange",
      };
    }

    return item;
  } else {
    // set ingredient
    set(ref(database, `analysis/${item.analysis_id}/ingredients/${item.flow_uid}`), item.ingredient_data);

    // var inputs_len = Object.values(Object.values(state.analysis.analysis_data.lca.lca_steps)[item.step_index]["inputs"]).length;
    const response = await get(child(ref(database), `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/`));
    const remote_keys = Object.entries(response.val()).map((x) => x[0]);
    const inputs_len = parseFloat(remote_keys.slice(-1)[0]) + 1;
    // while (remote_keys.includes(inputs_len)) {
    //   inputs_len = inputs_len + 1;
    // }
    // set flow
    set(ref(database, `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${inputs_len}`), item.lca_data);
    // const newData = push(ref(database, `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/`));
    // set(newData, lca_data);
  }
};
export const addIngredientLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[ADD_INGREDIENT_LOCAL]");
    await addIngredient_fn(getState, item, getFirebase, true);

    console.log("new_item", item);
    dispatch({
      type: "ADD_INGREDIENT_LOCAL",
      payload: { item: item },
    });
    // return new_item
  };
};
export const addIngredient = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    await addIngredient_fn(getState, item, getFirebase, false);
    ToastSuccess("Ingredient ajouté.");
    dispatch({ type: "ADD_INGREDIENT" });
  };
};
// REMOVE INGREDIENT
const removeIngredient_fn = async (item, getState) => {
  console.log("[REMOVE_FLOW_FROM_STEP_NDOO]", item);
  const tenant_id = auth.currentUser.tenantId;
  const database = firebase.app().database("https://" + tenant_id.toLowerCase() + ".firebaseio.com/");
  // const state = getState();
  // const analysis_data = state.analysis.analysis_data;
  // when delete in rdb, it doesnt update ids. So we need to get them and match local id with remote id.
  const response = await get(child(ref(database), `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/`));
  // console.log("get from", `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/`);
  console.log("response", response.val());
  const flow_id_remote = Object.entries(response.val()).find((x) => x && x[1].id === item.flow_id);
  // const flow_id_remote = Object.entries(response.val()).find((x) => x[1].flow.id === item.flow_uid)[0];
  // let flow_id_remote = await get_flow_id_remote(database, item, analysis_data);
  // console.log("flow_id_remote", flow_id_remote);
  // console.log("remove from", `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${flow_id_remote}`);
  ToastSuccess("Ingrédient supprimé.");
  // console.log('TATAMINA', item)
  // console.log('TATAMINANN', flow_id_remote)
  // remote from lca steps
  await remove(ref(database, `analysis/${item.analysis_id}/lca/lca_steps/${item.step_index}/inputs/${flow_id_remote[0]}`));
  // remote from ingredients
  await remove(ref(database, `analysis/${item.analysis_id}/ingredients/${item.flow_id}`));
};
export const removeIngredient = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_INGREDIENT]", item);
    await removeIngredient_fn(item, getState);
    dispatch({ type: "REMOVE_INGREDIENT" });
  };
};
export const removeIngredientLocal = (item) => {
  return async (dispatch, getState, { getFirebase }) => {
    console.log("[REMOVE_INGREDIENT_LOCAL]", item);
    dispatch({ type: "REMOVE_INGREDIENT_LOCAL", payload: { item: item } });
  };
};

async function get_ingredient_id_remote(database, item, index_raw_id, analysis_data) {
  const response = await get(child(ref(database), `analysis/${item.analysis_id}/ingredients/${item.flow_id}/${index_raw_id}/inputs/`));
  let flow_id_remote;
  if (item.current) {
    flow_id_remote = Object.entries(response.val()).find((x) => x && x[1].id === item.current.id)[0];
  } else {
    flow_id_remote = analysis_data.ingredients[item.flow_id][index_raw_id]["inputs"].length - 1;
  }
  return flow_id_remote;
}

////////////////////////////////////////////////////////////////////////////////////
//////////////////////////// --------- UTILS --------- /////////////////////////////
////////////////////////////////////////////////////////////////////////////////////

function get_index_raw_id(getState, item, category) {
  const state = getState();
  const analysis_data = state.analysis.analysis_data;
  // get id of category (K_Transports or K_Raw_Materials)
  let raw_id = Object.values(analysis_data["ingredients"][item.flow_id]).find(
    (x) => x.category.name === category //"K_Raw_Materials"
  );
  let index_raw_id;
  if (!raw_id) {
    index_raw_id = false;
  } else {
    raw_id = raw_id.id;
    index_raw_id = Object.values(analysis_data["ingredients"][item.flow_id]).findIndex((x) => x.id === raw_id);
  }
  // get index of raw_id

  return [index_raw_id, analysis_data];
}
